// @ts-ignore
import type * as SchemaTypes from '../../../../../index';

import { gql } from 'graphql-tag';
import { FilterPriceRangeFragmentDoc } from '../../../fragments/filters/filterPriceRange.fragment.generated';
import { FilterEngagementRingStyleFragmentDoc } from '../../../fragments/filters/filterEngagementRingStyle.fragment.generated';
import { FilterEngagementRingDesignFeatureFragmentDoc } from '../../../fragments/filters/filterEngagementRingDesignFeature.fragment.generated';
import { FilterEngagementRingDesignStyleFragmentDoc } from '../../../fragments/filters/filterEngagementRingDesignStyle.fragment.generated';
import { FilterShapeFragmentDoc } from './filterShape.fragment.generated';
import { MetalFilterFragmentDoc } from '../../../fragments/filters/metalFilter.fragment.generated';
export const EngagementRingFiltersFragmentDoc = gql`
    fragment engagementRingFilters on CatalogueEngagementRingFilters {
  price(input: {currency: $currency, region: $region}) {
    ...filterPriceRange
  }
  ringStyles {
    ...filterEngagementRingStyle
  }
  designFeatures {
    ...filterEngagementRingDesignFeature
  }
  designStyles {
    ...filterEngagementRingDesignStyle
  }
  centreStoneShapes {
    ...filterShape
  }
  primaryMetals {
    ...metalFilter
  }
}
    ${FilterPriceRangeFragmentDoc}
${FilterEngagementRingStyleFragmentDoc}
${FilterEngagementRingDesignFeatureFragmentDoc}
${FilterEngagementRingDesignStyleFragmentDoc}
${FilterShapeFragmentDoc}
${MetalFilterFragmentDoc}`;